// The metadata prompt makes every generated title end with its category —
// "… Embroidery Design", "… SVG" — because those are the words people type into
// search, and seoTitle is what Algolia ranks on. Inside the app that context is
// already set by the tab you're standing in, so in a narrow grid cell the suffix
// only crowds out the part that actually distinguishes one design from another.
//
// Shortening here rather than asking the model for a second title keeps this
// working on designs that were already published, and keeps seoTitle untouched
// for search.

// Ordered longest-first so "machine embroidery design" is consumed whole instead
// of leaving "machine" behind.
const TRAILING_CATEGORY = [
  "machine embroidery designs",
  "machine embroidery design",
  "embroidery designs",
  "embroidery design",
  "embroidery patterns",
  "embroidery pattern",
  "embroidery files",
  "embroidery file",
  "embroidery",
  "svg cut files",
  "svg cut file",
  "svg files",
  "svg file",
  "svg",
  "cut files",
  "cut file",
  "designs",
  "design",
  "patterns",
  "pattern",
  "files",
  "file",
];

const CATEGORY_WORDS = new Set([
  "machine",
  "embroidery",
  "design",
  "designs",
  "svg",
  "cut",
  "file",
  "files",
  "pattern",
  "patterns",
]);

// Guards against gutting a title that never named its subject. When the model
// returns bare boilerplate like "Machine Embroidery Design", stripping the
// suffix leaves "Machine", which is worse than showing the whole thing.
const isOnlyCategoryWords = (value) =>
  value
    .split(/[\s\-–—|,:]+/)
    .filter(Boolean)
    .every((word) => CATEGORY_WORDS.has(word.toLowerCase()));

// A separator is required before the phrase, so a title that is nothing but its
// category ("SVG") is left alone instead of being emptied.
const stripTrailingCategory = (value) => {
  for (const phrase of TRAILING_CATEGORY) {
    const pattern = new RegExp(`[\\s\\-–—|,:]+${phrase.replace(/ /g, "\\s+")}\\s*$`, "i");
    if (!pattern.test(value)) continue;
    const stripped = value.replace(pattern, "").trim();
    if (stripped && !isOnlyCategoryWords(stripped)) return stripped;
  }
  return null;
};

export const getShortTitle = (title) => {
  const base = (title || "").trim();
  if (!base) return "";

  // Repeated because stacked categories are common — "… Embroidery Design File"
  // needs "File" gone before "Embroidery Design" is at the end to be matched.
  let short = base;
  for (let pass = 0; pass < 3; pass += 1) {
    const next = stripTrailingCategory(short);
    if (!next) break;
    short = next;
  }
  return short;
};
